import React from "react";

const Social = () => {
  return (
    <div
      id="social-connect"
      className="uk-margin-medium  uk-width-3-5@s uk-width-4-5"
    >
      <h4 className="app-text">Connect to social media</h4>
      <ul className="uk-padding-remove uk-list">
        <li className="uk-flex uk-width-1-1">
          <span style={{ color: "#3b5998" }}>
            <i className="fa fa-lg fa-facebook" aria-hidden="true"></i>
          </span>
          <span style={{ color: "#1ed607" }}>
            <i className="material-icons-outlined">check_circle</i>
          </span>
        </li>
        <li>
          <span style={{ color: "#1da1f2" }}>
            <i className="fa fa-lg fa-twitter" aria-hidden="true"></i>
          </span>
          <span>
            <i className="material-icons-outlined">add</i>
          </span>
        </li>
        <li>
          <span style={{ color: "#c32aa3" }}>
            <i className="fa fa-lg fa-instagram" aria-hidden="true"></i>
          </span>
          <span style={{ color: "#1ed607" }}>
            <i className="material-icons-outlined">check_circle</i>
          </span>
        </li>
        <li>
          <span style={{ color: "#ff0000" }}>
            <i className="fa fa-lg fa-youtube" aria-hidden="true"></i>
          </span>
          <span style={{ color: "#1ed607" }}>
            <i className="material-icons-outlined">check_circle</i>
          </span>
        </li>
      </ul>
    </div>
  );
};

export default Social;
